<template>
  <div>
    <ul class="nav nav-tabs mb-4">
      <li class="nav-item"><b-link :to="{ name: 'MarketRates' }"
          :class="{ 'nav-link': true, active: this.$route.name === 'MarketRates' }">Market Rates</b-link></li>
      <li class="nav-item"><b-link :to="{ name: 'ActiveRoutes' }"
          :class="{ 'nav-link': true, active: this.$route.name === 'ActiveRoutes' }">Active routes</b-link></li>
      <li class="nav-item"><b-link :to="{ name: 'MarketRatesMap' }"
          :class="{ 'nav-link': true, active: this.$route.name === 'MarketRatesMap' }">Location map</b-link></li>
      <li class="nav-item"><b-link :to="{ name: 'Calculator' }"
          :class="{ 'nav-link': true, active: this.$route.name === 'Calculator' }">Calculator</b-link></li>
    </ul>
    <div class="card mb-4">
      <b-form inline @submit.prevent="submit" class="px-4 pt-3 d-flex align-items-end" style="gap: 30px;" autocomplete="off">
        <div class="d-flex align-items-end" style="gap: 10px;">
          <div  class="position-relative">
            Pickup:
            <LocationPicker v-model="pickupLocation" :req="true"  size="md"/>
            <div v-if="errors.pickupLocation && errors.pickupLocation.length" class="text-danger position-absolute w-100" style="top: 100%; left: 0;">
              <small v-for="error in errors.pickupLocation" :key="error">{{error}}</small>
            </div>
          </div>
          <div  class="position-relative">
            Delivery:
            <LocationPicker v-model="deliveryLocation" :req="true" size="md"/>
            <div v-if="errors.deliveryLocation && errors.deliveryLocation.length" class="text-danger position-absolute w-100" style="top: 100%; left: 0;">
              <small v-for="error in errors.deliveryLocation" :key="error">{{error}}</small>
            </div>

          </div>
          <div>
            <button class="btn"
              :class="(!pickupLocation || !deliveryLocation) ? 'btn-outline-secondary' : 'btn-outline-primary'"
              type="button" :disabled="!pickupLocation || !deliveryLocation" @click="handleRouteClicked">Show
              Route</button>
          </div>
          <div style="margin-bottom: 6px;">
            <b-button-group size="sm">
              <a title="25 Miles Around" class="btn border-left-pill btn-secondary" target="_blank"
                rel="noreferrer noopener" :href="getCDLink(25)">
                <i class="fas fa-angle-right"></i>
              </a>
              <a title="50 Miles Around" class="btn btn-secondary" target="_blank" rel="noreferrer noopener"
                :href="getCDLink(50)">
                <i class="fas fa-angle-double-right"></i>
              </a>
              <a title="100 Miles Around" class="btn border-left-pill btn-secondary" target="_blank"
                rel="noreferrer noopener" :href="getCDLink(100)">
                <i class="fas fa-angle-right"></i>
                <i style="margin-left: -0.28rem" class="fas fa-angle-double-right"></i>
              </a>
            </b-button-group>
          </div>
        </div>

        <div class="form-group mb-0" style="width: 200px;">
          <label for="vechile-types" class="form-label mb-1">Vehicle Type:</label>
          <ValidatedSelect
            v-model="vehicleTypeId"
            :options="vehicleTypes"
            :option-label-key="'text'"
            :option-value-key="'value'"
            :required="true"
            id="vechile-types"
            class="w-100"
          />
        </div>

        <button class="btn btn-primary" type="submit">Calculate</button>
      </b-form>

      <RouteMapModal id="cardRouteModal" :route="routeInfo" />

      <div class="card-body">
        <LoadingIndicator v-if="loading" centered />
        <div v-if="result">
          <p>Distance: <b>{{ result.miles }}</b> miles</p>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Standard</th>
                <th>Expedited</th>
                <th>Enclosed</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ result.prices.standard }}</td>
                <td>{{ result.prices.expedited }}</td>
                <td>{{ result.prices.standard + parseInt(result.transportType.enclosed) }}</td>
              </tr>
            </tbody>
          </table>

          <div v-if="$store.getters['auth/tokenCan']('admin')" class="mt-3">
            <h4>Quote Breakdown:</h4>
            <div v-for="(arr, propertyName) in result.debug" :key="propertyName">
              <b>{{ propertyName }}</b>
              <ul class="mb-1">
                <li v-for="item in arr" :key="item[0]">
                  {{ item[0] }}: {{ item[2] || null }} <span>({{ item[1] }})</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <!--div v-if="$store.getters['auth/tokenCan']('admin')" class="card-body">
        <LoadingIndicator v-if="loading2" centered />
        <div v-if="result2">
          <p>Distance: <b>{{ result2.miles }}</b> miles</p>
          <table class="table table-bordered">
            <thead>
              <tr>
                <th>Standard</th>
                <th>Expedited</th>
                <th>Enclosed</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{{ result2.prices.standard }}</td>
                <td>{{ result2.prices.expedited }}</td>
                <td>{{ result2.prices.standard + parseInt(result2.transportType.enclosed) }}</td>
              </tr>
            </tbody>
          </table>

          <div v-if="$store.getters['auth/tokenCan']('admin')" class="mt-3">
            <h4>Quote Breakdown:</h4>
            <div v-for="(arr, propertyName) in result2.debug" :key="propertyName">
              <b>{{ propertyName }}</b>
              <ul class="mb-1">
                <li v-for="item in arr" :key="item[0]">
                  {{ item[0] }}: {{ item[2] || null }} <span>({{ item[1] }})</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div-->
    </div>
  </div>
</template>

<script>

import { ApiClient } from '@/api/ApiClient';
import LoadingIndicator from '@/components/shared/LoadingIndicator';
import LocationPicker from '@/components/shared/LocationPicker';
import RouteMapModal from '@/components/shared/route/RouteMapModal';
import ValidatedSelect from '@/components/shared/ValidatedMultiselect.vue';

export default {
  name: 'Calculator',
  data() {
    return {
      loading: false,
      loading2: false,
      result: null,
      result2: null,
      errors: {},
      pickupLocation: '',
      deliveryLocation: '',
      vehicleTypeId: null,
      vehicleTypes: [
        { text: 'Small Car', value: 3 },
        { text: 'Small SUV', value: 21 },
        { text: 'Medium Pickup', value: 8 },
        { text: 'Mini-van', value: 29 },
        { text: 'Midsize Car', value: 2 },
        { text: 'Midsize SUV', value: 1 },
        { text: 'Large Pickup', value: 9 },
        { text: 'Hypercar', value: 25 },
        { text: 'Motorcycle', value: 18 },
        { text: 'Large Car', value: 4 },
        { text: 'Large SUV', value: 22 },
        { text: 'Dually Pickup', value: 12 },
        { text: 'Fullsize van', value: 11 },
        { text: 'Sports Car', value: 20 },
        { text: 'Travel Trailer', value: 24 },
        { text: 'Boat Trailer', value: 23 },
        { text: 'Golf Cart', value: 19 },
      ],
      routeInfo: { id: null, origin: null, destination: null, infoHtml: null },
    };
  },
  components: {
    LoadingIndicator,
    LocationPicker,
    RouteMapModal,
    ValidatedSelect,
  },
  methods: {
    handleRouteClicked() {

      this.routeInfo = {
        id: 'Route',
        origin: `${this.pickupLocation}`,
        destination: `${this.deliveryLocation}`,
        infoHtml: `(A) ${this.pickupLocation}
          <i class="mx-1 fa-lg fas fa-shipping-fast"></i>
          (B) ${this.deliveryLocation}`
      }
      this.$bvModal.show('cardRouteModal');
    },
    getCDLink(distance) {
      const pickup = this.parseLocation(this.pickupLocation);
      const delivery = this.parseLocation(this.deliveryLocation);

      if (pickup.city == null || delivery.city == null) {
        return "#";
      }

      let url = 'https://app.centraldispatch.com/search?search=' +
        '~(vC~(mn~1)~tLPW~2~opt~%27all~ofst~0~lmt~50~sF~(~(n~%27pup~d~%27ASC)~(n~%27dMA~d~%27ASC))~dBS~false~sPSO~false~sTOT~false~rT~%27Open~l~(~(c~%27' +
        pickup.city?.replace(' ', '*20') +
        '~st~%27' +
        pickup.state +
        //'~zC~%27'+
        //this.lead.pickupLocation.zip +
        '~r~' +
        distance +
        '~s~%27Pickup)~(c~%27' +
        delivery.city?.replace(' ', '*20') +
        '~st~%27' +
        delivery.state +
        //'~zC~%27' +
        //this.lead.deliveryLocation.zip +
        '~r~' +
        distance +
        '~s~%27Dropoff)))';
      return url;
    },
    parseLocation(location) {
      const parts = location.split(',').map(part => part.trim());
      if (parts.length === 3) {
        return {
          zip: parts[0],
          city: parts[1],
          state: parts[2]
        };
      } else if (parts.length === 2) {
        return {
          zip: null,
          city: parts[0],
          state: parts[1]
        };
      } else {
        return {
          zip: null,
          city: null,
          state: null
        };
      }
    },
    async submit(e) {
      e.preventDefault();
      this.fetch();
    },
    async fetch() {

      this.result = null
      this.result2 = null
      this.errors = {}

      if (!this.pickupLocation || !this.deliveryLocation) return;

      await this.fetch1()
      //await this.fetch2()
    },
    async fetch1(){
      this.loading = true;
      const response = await ApiClient.calculations.get({
        params: { pickupLocation: this.pickupLocation, deliveryLocation: this.deliveryLocation, vehicleTypeId: this.vehicleTypeId },
      });

      if(response.status === 200) {
        this.result = response.data.data.result;
      }
      if(response.status === 422){
        this.errors= response.data.errors

        Object.values(this.errors).forEach(errorArray => {
          errorArray.forEach(errorMsg => {
            this.$bvToast.toast(errorMsg, {
              title: 'Error',
              variant: 'danger',
              solid: true,
              autoHideDelay: 8000
            });
          });
        });
      }
      this.loading = false;
    },
    async fetch2(){
      this.loading2 = true;

      const response2 = await ApiClient.calculations.v2({
        params: { pickupLocation: this.pickupLocation, deliveryLocation: this.deliveryLocation, vehicleTypeId: this.vehicleTypeId },
      });

      if(response2.status === 200){
        this.result2 = response2.data.data.result;
      }

      if(response2.status === 422){
        this.errors= response2.data.errors
      }
      this.loading2 = false;
    }
  },
};
</script>

<style lang="scss" scoped>
.zip {
  width: 60px;
}
</style>